import React from "react";
import moment from "moment-timezone";

import { PaginatedData } from "src/library/utils";

import {
  IOrder,
  ListOrdersByDropParams,
  ordersApi
} from "../api/orders.api";

type OrderDeliveryDatesReturnType = [{
  orderDates: Array<{ id: number; date: Date }>,
  currentOrders: IOrder[]
},
{ getCalendarOrderDates: (dropId: number, currentMonth: {
  month: number;
  year: number;
}) => void }];

/**
 * Hook to provide functionality for loading dates by month/year
 */
export const useOrderDeliveryDates: () => OrderDeliveryDatesReturnType = () => {
  const [ orderDates, setOrderDates ] = React.useState<Array<{ id: number; date: Date }>>([]);
  const [ currentOrders, setCurrentOrders ] = React.useState<IOrder[]>([]);
  const [ ordersResponse, getOrders ] = ordersApi<{ orders: PaginatedData<IOrder> }>("LIST_DROP_ORDERS");

  /** Get the calendar dates */
  const getCalendarOrderDates = React.useCallback((dropId: number, currentMonth: {
    month: number;
    year: number;
}) => {
    if (currentMonth) {
      getOrders<ListOrdersByDropParams>({
        pagination: {
          offset: 0,
          page: 0,
          sort: [ [ "id", "DESC" ] ],
          limit: 100
        },
        filters: {
          type: { $ne: "bulk" },
          orderDeliveryDate: {
            $between: [
              moment
                .utc()
                .month(currentMonth.month)
                .year(currentMonth.year)
                .startOf("month")
                .toDate(),
              moment
                .utc()
                .month(currentMonth.month)
                .year(currentMonth.year)
                .endOf("month")
                .toDate()
            ]
          }
        },
        dropId
      });
    }
  }, []);

  /** handle the response of the and reformat it into date and id objects array */
  React.useEffect(() => {
    if (ordersResponse.data) {
      const newOrderDates: Array<{ id: number; date: Date }> = [];
      const newOrders: IOrder[] = [];

      if (ordersResponse && ordersResponse.data && ordersResponse.data.orders && ordersResponse.data.orders.result) {
        for (const order of ordersResponse.data.orders.result) {
          if (!order.orderStatus || order.orderStatus.settings.group !== "CANCELLED") {
            newOrderDates.push({
              id: order.id,
              date: order.orderDeliveryDate as Date
            });
            newOrders.push(order);
          }
        }

        setCurrentOrders(newOrders);
        setOrderDates(newOrderDates);
      }
    }
  }, [ ordersResponse ]);

  return [
    {
      orderDates,
      currentOrders
    },
    { getCalendarOrderDates }
  ];
};
